// Wrap a callback to achieve the same effect
// but without propagation. Or just pass this
// function into an event handler, e.g. onClick,
// to stop any further propagation
export const no_propagate = (arg) => {
    if (typeof arg === "function") {
        const callback = arg;
        // If called with a callback, alter the callback and return it.
        const callback_without_propagate = (e) => {
            e.stopPropagation();
            callback()
        }
        return callback_without_propagate;
    } else {
        // As a bare function, arg is an event
        const e = arg;
        e.stopPropagation();
    }
}
